<template>
  <div class>
    <STable
      ref="tableref"
      :url="url"
      :columns="columns"
      :handles="handles"
      :query="query"
      :selection="true"
      label-width="120px"
    />
    <el-dialog
      v-dialogDrag
      title="评论回复"
      :visible.sync="dialogVisible"
      :before-close="cancel"
      width="70%"
      center
    >
      <el-form ref="form" :model="form" :rules="rules" label-width="120px">
        <el-form-item label="评价内容" prop="equipmentOwnerID">
          <div>{{ context }}</div>
        </el-form-item>
        <el-form-item label="回复" prop="equipmentOwnerID">
          <el-input
            v-model="form.remark"
            type="textarea"
            :rows="4"
            placeholder="请输入内容"
          />
        </el-form-item>
      </el-form>
      <div class="btns" style="margin-top:30px; display: flex; align-items: center; justify-content:center;">
        <el-button @click="cancel">取消</el-button>
        <el-button type="primary" @click="save">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request.js'

// import x from ''
export default {
  name: 'Tongzhiguanli',
  components: {},
  data() {
    return {
      dialogVisible: false,
      context: '',
      id: '',
      form: {
        remark: ''
      },
      url: '/business/comment/page',
      columns: [
        {
          label: '站点名称',
          prop: 'siteName'
        },
        {
          label: '评论用户',
          prop: 'commentUser'
        },
        {
          label: '评论内容',
          prop: 'commentContext'
        },
        {
          label: '评论时间',
          prop: 'commentTime'
        },
        {
          label: '回复状态',
          prop: 'isCommented',
          template: function(index, reocrd) {
            return reocrd.isCommented === 1
              ? '已回复'
              : '未回复'
          }
        },
        {
          label: '移动端展示状态',
          prop: 'isClosed',
          template: function(index, reocrd) {
            return reocrd.isClosed === 0
              ? '正常'
              : '已关闭'
          }
        }
      ],
      handles: {
        width: 200,
        btns: [
          {
            label: '回复',
            icon: 'el-icon-chat-round',
            permission: 'comment.reply',
            // style: "color:red",
            getLabel: function(record) {
              return record.isCommented === 1 ? '已回复' : '回复'
            },
            before: (index, record) => {
              if (record.isCommented === 1) {
                this.dialogVisible = false
              } else {
                this.dialogVisible = true
                console.log('record', record)
                this.context = record.commentContext
                this.id = record.id
              }
            }
          },
          {
            label: '关闭',
            permission: 'comment.delete',
            style: 'color:red',
            getLabel: function(record) {
              return record.isClosed === 0 ? '关闭' : ''
            },
            url: '/business/comment/close',
            method: 'get',
            isConfirm: true,
            confirmText: '已关闭的评论不在移动端展示，是否继续？',
            before: function(index, record) {
              const p = {
                id: record.id
              }
              return p
            },
            handle: resp => {
              this.$refs.tableref.queryTable()
            }
          }
        ]
      },
      query: [
        {
          label: '站点名称',
          prop: 'siteName',
          placeholder: '请输入站点名称'
        },
        {
          label: '评论用户',
          prop: 'commentUser',
          placeholder: '请输入评论用户'
        },
        {
          label: '评论内容',
          prop: 'commentContext',
          placeholder: '请输入评论内容'
        },
        {
          label: '回复状态',
          prop: 'isCommented',
          type: 'select',
          placeholder: '请选择状态',
          data: [{
            value: '0',
            label: '未回复'
          }, {
            value: '1',
            label: '已回复'
          }]
        },
        {
          label: '移动端展示状态',
          prop: 'isClosed',
          type: 'select',
          placeholder: '请选择状态',
          data: [{
            value: '0',
            label: '正常'
          }, {
            value: '1',
            label: '已关闭'
          }]
        },
        {
          label: '时间',
          prop: 'commentTime',
          type: 'date2'
        }
      ],
      //   toolbar: [
      //     {
      //       label: "新增",
      //       permission: "",
      //       type: "primary",
      //       handle: resp => {
      //         this.dialogVisible = true;
      //       }
      //     },]
      rules: {

      }
    }
  },
  computed: {

  },
  methods: {
    cancel() {
      this.dialogVisible = false
      this.form = {
        remark: ''
      }
    },

    save() {
      const data = {
        id: this.id,
        reply: this.form.remark
      }
      this.$store.dispatch('form/handle', {
        url: '/business/comment/post',
        data: data,
        method: 'post',
        callback: resp => {
          console.log('resp', resp)
          this.dialogVisible = false
          this.$refs.tableref.queryTable()
        }
      })
    }
  } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style lang="less" src="" scoped>
.btn {
  width: 600px;
  height: 50px;
  margin-top: 10px;
  margin-left: 40%;
}
</style>



// WEBPACK FOOTER //
// src/views/plantComment/plantcomment.vue